import React, { useState, useEffect, useRef } from "react";
import "./portfolioInfoPopup.css";
import { Button, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useSearchParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import { toast } from "react-toastify";
import { updatePortfolioDescription } from "Config/API/get";
import { useSelector } from "react-redux";

const PortfolioInfoPopup = ({ selectedInfoItem, hide, getPortfolio }) => {
  const [description, setDescription] = useState(selectedInfoItem?.description);

  const [isEditing, setIsEditing] = useState(false);
  const linkTag = useRef();
  const token = localStorage.getItem("token");
  useEffect(() => {
    setDescription(selectedInfoItem?.description || "");
    setIsEditing(false); // reset edit state when item changes
  }, [selectedInfoItem]);

  const handleSave = async () => {
    try {
      const res = await updatePortfolioDescription(
        token,
        selectedInfoItem?.unique_id,
        description
      );

      if (res.data?.status) {
        setIsEditing(false);
        toast("Description updated!", { type: "success" });

        await getPortfolio(); // ✅ This will trigger the refetch correctly
      }
    } catch (error) {
      console.error("Failed to update:", error);
      toast("Session expired or request failed.", { type: "error" });
    }
  };

  const openFile = (item) => {
    if (!item) return;
    localStorage.setItem("filePath", item.path);
    localStorage.setItem("fileType", item.key?.split(".").pop()?.toLowerCase());
    linkTag.current?.click();
  };

  const extension =
    selectedInfoItem?.type === "webLink"
      ? selectedInfoItem?.path
      : selectedInfoItem?.key?.split(".").pop()?.toLowerCase() || "N/A";

  const getFileCategory = (ext) => {
    if (!ext) return "Unknown";
    if (/(jpe?g|png|gif|bmp|webp)$/i.test(ext)) return "Image";
    if (/(mp4|webm|ogg|mov)$/i.test(ext)) return "Video";
    if (/(mp3|wav|m4a|flac)$/i.test(ext)) return "Audio";
    if (/pdf$/i.test(ext)) return "PDF";
    if (/(docx?|xlsx?|pptx?)$/i.test(ext)) return "Document";

    if (/(txt|csv|json|xml|log|md|html|js|ts|css)$/i.test(ext))
      return "Text File";
    if (/(stl|obj|3ds|fbx|step|stp|igs|iges|dxf)$/i.test(ext))
      return "3D Model / CAD";
    if (selectedInfoItem?.type === "webLink") return "weblink";
    return "Other";
  };
  const loggedInUserId = useSelector(
    (state) => state.authenticationReducer?.id
  );

  const general_info = useSelector((state) => state.renderGeneralInfo);
  const portfolio_role = useSelector(
    (state) => state.authenticationReducer?.portfolio_role
  );
  const workbook_role = useSelector(
    (state) => state.authenticationReducer?.workbook_role
  );
  console.log(
    general_info.role,
    loggedInUserId,
    selectedInfoItem?.org_id,
    portfolio_role,
    workbook_role,
  );
  console.log("user_id:", typeof loggedInUserId, loggedInUserId);

  const fileTypeLabel = getFileCategory(extension);
  const safeUrl =
    selectedInfoItem?.path?.startsWith("http://") ||
      selectedInfoItem?.path?.startsWith("https://")
      ? selectedInfoItem.path
      : `https://${selectedInfoItem?.path}`;
  return (
    <div className="info-modal-backdrop" onClick={() => hide(false)}>
      <div className="info-modal" onClick={(e) => e.stopPropagation()}>
        <Link
          ref={linkTag}
          to="/file-explorer/file-viewer"
          target="_blank"
          style={{ display: "none" }}
        >
          Open
        </Link>

        <div className="info-close-icon" onClick={() => hide(false)}>
          <CloseIcon />
        </div>

        <div className="info-modal-title">
          {selectedInfoItem?.name || "Untitled"}
        </div>

        <div className="info-modal-content">
          <div className="info-left">
            <p>
              <strong>File Type: </strong>
              {fileTypeLabel}
            </p>
            <p>
              <strong>Extension: </strong>
              {extension}
            </p>
          </div>

          <div className="info-right">
            {selectedInfoItem?.type === "file" && selectedInfoItem?.path ? (
              /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(selectedInfoItem.key) ? (
                <img
                  src={selectedInfoItem.path}
                  alt="Preview"
                  style={{
                    width: "100%",
                    maxHeight: "200px",
                    objectFit: "contain",
                  }}
                />
              ) : /\.(mp4|webm|ogg|mov|avi|mpeg|mpg|m4v|mkv|3gp|flv|ogv)$/i.test(
                selectedInfoItem.key
              ) ? (
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    maxHeight: "200px",
                  }}
                >
                  <video
                    src={selectedInfoItem.path}
                    preload="metadata"
                    muted
                    playsInline
                    onLoadedMetadata={(e) => e.currentTarget.pause()}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      pointerEvents: "none",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      background: "rgba(0,0,0,0.6)",
                      borderRadius: "50%",
                      padding: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      fill="#fff"
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
              ) : /\.(mp3|wav|m4a|flac|aac|oga|opus)$/i.test(
                selectedInfoItem.key
              ) ? (
                <div style={{ pointerEvents: "none" }}>
                  <audio
                    controls
                    src={selectedInfoItem.path}
                    style={{ width: "100%" }}
                  />
                </div>
              ) : /\.(docx?|xlsx?|pptx?|pdf|txt|csv|json|xml|log|md|html?|js|ts|tsx|css|yml|yaml|ini|sh|py|java|c|cpp|rb|php|sql|vue|jsx|swift|go|scala)$/i.test(
                selectedInfoItem.key
              ) ? (
                <div
                  style={{
                    width: "100%",
                    height: "200px",
                    overflow: "hidden", // Prevent scrolling in the container
                    position: "relative",
                  }}
                >
                  <iframe
                    src={`https://docs.google.com/gview?url=${encodeURIComponent(
                      selectedInfoItem.path
                    )}&embedded=true`}
                    title="Document Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      pointerEvents: "none", // Prevent interaction
                    }}
                  />
                </div>
              ) : // : /\.(stl|obj|3ds|fbx|step|stp|igs|iges|dxf|3mf|gltf|glb)$/i.test(
                //     selectedInfoItem.key
                //   ) ? (
                //     <iframe
                //     src={`${selectedInfoItem.path}`}

                //     style={{
                //       width: "100%",
                //       height: "300px",
                //       border: "none"
                //     }}
                //     allowFullScreen
                //     title="3D Model Preview"
                //   />
                // )
                /\.(ttf|otf|woff2?|eot)$/i.test(selectedInfoItem.key) ? (
                  <div>
                    <style>
                      {`
                    @font-face {
                      font-family: 'CustomFontPreview';
                      src: url('${selectedInfoItem.path}');
                    }
                  `}
                    </style>
                    <div
                      style={{
                        fontFamily: "CustomFontPreview",
                        fontSize: "24px",
                        padding: "10px",
                        textAlign: "center",
                        background: "#f5f5f5",

                        border: "none",
                        width: "100%",
                        height: "200px",
                      }}
                    >
                      <strong>Font Preview:</strong>
                      <br />
                      FONT FILE FONT STYLE PREVIEW
                    </div>
                  </div>
                ) : (
                  <div style={{ color: "#888" }}>
                    This file type cannot be previewed.
                    <br />
                    <span
                      onClick={() => openFile(selectedInfoItem)}
                      style={{
                        color: "#446fa2",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      Click here to view/download
                    </span>
                  </div>
                )
            ) : (
              <div
                style={{
                  color: "#888",
                  width: "100%",
                  height: "200px",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <iframe
                  src={safeUrl}
                  title="Document Preview"
                  // scrolling="no"
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    overflow: "hidden",
                  }}
                  sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                  allow="fullscreen"
                />
              </div>
            )}
          </div>
        </div>

        {/* Description Section */}
        <div className="info-description">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h4 style={{ margin: 0 }}>Description</h4>
            {!isEditing &&
              (Number(selectedInfoItem?.org_id) === Number(general_info.id) || Number(general_info.id) === 1) &&
              (portfolio_role === "manager" || workbook_role === "manager" || general_info.role === "super_admin") && (
                <EditIcon
                  style={{ cursor: "pointer", color: "#446fa2" }}
                  onClick={() => setIsEditing(true)}
                />
              )}
          </div>

          <TextField
            multiline
            fullWidth
            variant="outlined"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            InputProps={{
              readOnly: !isEditing,
            }}
            inputProps={{
              maxLength: 300, // Limit input to 300 characters
            }}
            sx={{
              mt: 1,
              "& .MuiOutlinedInput-root": {
                padding: "0px",
                alignItems: "flex-start",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: isEditing ? "#ccc" : "transparent", // Removes double border when not editing
              },
              "& .MuiInputBase-inputMultiline": {
                resize: "none", // ❌ disables resize handle
                overflowY: "auto",
              },
            }}
          />

          {isEditing && (
            <div style={{ marginTop: "8px", textAlign: "right" }}>
              <Button
                variant="contained"
                size="small"
                onClick={handleSave}
                style={{ background: "#446fa2", textTransform: "none" }}
                startIcon={<SaveIcon />}
              >
                Save
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PortfolioInfoPopup;
